import { render, staticRenderFns } from "./m-slide.vue?vue&type=template&id=023420fd"
import script from "./m-slide.vue?vue&type=script&lang=js"
export * from "./m-slide.vue?vue&type=script&lang=js"
import style0 from "./m-slide.vue?vue&type=style&index=0&id=023420fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports